var _circle, _path, _path2, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.6426,
    cy: 76.6418,
    r: 34.9921,
    transform: "rotate(-0.395643 76.6426 76.6418)",
    fill: "#ECB48B",
    stroke: "#B38E67",
    strokeWidth: 6.77267
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.7071 59.2929C76.3166 58.9024 75.6834 58.9024 75.2929 59.2929L68.9289 65.6569C68.5384 66.0474 68.5384 66.6805 68.9289 67.0711C69.3195 67.4616 69.9526 67.4616 70.3431 67.0711L76 61.4142L81.6569 67.0711C82.0474 67.4616 82.6805 67.4616 83.0711 67.0711C83.4616 66.6805 83.4616 66.0474 83.0711 65.6569L76.7071 59.2929ZM77 75L77 60L75 60L75 75L77 75Z",
    fill: "#AF8157"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.782 93.5724C93.3343 93.5686 93.7789 93.1178 93.7751 92.5655L93.7129 83.5658C93.7091 83.0135 93.2583 82.5689 92.7061 82.5727C92.1538 82.5765 91.7092 83.0273 91.713 83.5796L91.7682 91.5794L83.7684 91.6346C83.2161 91.6384 82.7715 92.0892 82.7753 92.6415C82.7792 93.1938 83.23 93.6384 83.7822 93.6346L92.782 93.5724ZM77.2978 78.712L92.0729 93.2844L93.4773 91.8605L78.7022 77.288L77.2978 78.712Z",
    fill: "#AF8157"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.41,
    cy: 76.41,
    r: 2.82226,
    transform: "rotate(-0.395643 76.41 76.41)",
    fill: "#AF8157",
    stroke: "#AF8157",
    strokeWidth: 1.12878
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 46,
    width: 3,
    height: 6,
    fill: "#FFE0C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 97.2422,
    y: 57,
    width: 3,
    height: 6,
    transform: "rotate(45 97.2422 57)",
    fill: "#FFE0C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62.2422,
    y: 93,
    width: 3,
    height: 6,
    transform: "rotate(45 62.2422 93)",
    fill: "#FFE0C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 94.0938,
    width: 3,
    height: 6,
    transform: "rotate(-44.2411 93 94.0938)",
    fill: "#FFE0C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 57.0938,
    width: 3,
    height: 6,
    transform: "rotate(-44.2411 55 57.0938)",
    fill: "#FFE0C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 100,
    width: 3,
    height: 6,
    fill: "#FFE0C4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 74,
    width: 3,
    height: 6,
    transform: "rotate(90 54 74)",
    fill: "#FFE0C4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 74,
    width: 3,
    height: 6,
    transform: "rotate(90 107 74)",
    fill: "#FFE0C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCon1);
export default __webpack_public_path__ + "static/media/con-1.d5f882d349ac0b916eacf94f037055b5.svg";
export { ForwardRef as ReactComponent };